import { Star, Quote } from "lucide-react";

import { Reveal } from "@/components/site/Reveal";
import { business, reviews } from "@/lib/business";

export function Reviews() {
  return (
    <section
      id="reviews"
      className="scroll-mt-28 border-b border-border bg-secondary/40 py-20 sm:py-28"
      aria-labelledby="reviews-heading"
    >
      <div className="mx-auto max-w-6xl px-4">
        <Reveal>
          <p className="eyebrow">Reviews</p>
          <h2 id="reviews-heading" className="mt-3 text-4xl uppercase sm:text-5xl">
            What customers say
          </h2>
          <p className="mt-4 max-w-2xl text-muted-foreground">
            Our reputation is built one engine at a time. Here's what folks tell us after their
            build is back on the road or back in the field.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 md:grid-cols-3">
          {reviews.map((review, index) => (
            <Reveal key={review.name} as="li" delay={index * 110} className="h-full">
              <figure className="surface-card flex h-full flex-col p-6">
                <Quote className="size-7 text-primary-text" aria-hidden="true" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted-foreground">
                  <p>“{review.text}”</p>
                </blockquote>
                <div
                  className="mt-5 flex items-center gap-1"
                  role="img"
                  aria-label="5 out of 5 stars"
                >
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      className="size-4 fill-primary-text text-primary-text"
                      aria-hidden="true"
                    />
                  ))}
                </div>
                <figcaption className="mt-2 text-sm font-semibold">{review.name}</figcaption>
              </figure>
            </Reveal>
          ))}
        </ul>

        <div className="mt-10">
          <a
            href={business.googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-base btn-primary"
          >
            Leave a review on Google
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
        </div>
      </div>
    </section>
  );
}
